import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AgreementType } from "@shared/enums/agreementType";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { HouseType } from "@shared/enums/houseType";
import { PackagesType } from "@shared/enums/packages-type";
import { RiskItemInformations } from "@shared/enums/riskItemInformations";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-options-list-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./options-list-mrh.component.html",
  styleUrl: "./options-list-mrh.component.scss",
})
export class OptionsListMrhComponent implements OnInit {
  @Input() details!: any;
  hasValuableObject = false;

  options = FormulasOptions;
  packageType = PackagesType;
  agreementType = AgreementType;
  riskItemInfo = RiskItemInformations;
  houseType = HouseType;

  ngOnInit() {
    this.checkValuableObject();
    this.checkHouseType();
  }

  checkValuableObject() {
    this.hasValuableObject = this.details.formulasAndOptionsInformations.options.some(
      (item: any) => item.type === this.options.OBJVAL
    );
  }

  checkHouseType() {
    const houseType = this.details.riskItemInformations.values.find(
      (item: any) => item.code === this.riskItemInfo.HAB_TYPE
    ).value;
    return houseType;
  }

  isContract() {
    return this.details.agreementType === this.agreementType.CP;
  }
}
